import React, { useEffect, useState, useRef } from "react";
import "./Listview.css";
import { Spinner } from "react-bootstrap";
import appUser from "../../assets/app_user_icon.png";
import amUser from "../../assets/am_icon.png";
import Hexapi from "../../utility/HexAPI/Hexapi";
import GetImage from "../../components/getimage/Getimage";
import SearchComponent from "../../components/searchcomponent/SearchComponent";
import withRouter from "../../utility/withRouter";
import { decodeUrl } from "../../utility/decodesearchurl";
import { TicketScore } from "../../components/ticketscore/Ticketscore";
import Tint from "../../utility/ImageTint/Tint";
import { useNavigate } from "react-router";
import Loader from "../../components/loader/Loader";
import config from "../../colors/config";
const ListView = (props) => {
  const [EmpID, setEmpID] = useState(null);
  const [Username, setUsername] = useState(null);
  const [userid, setUserid] = useState(props?.userid);
  const [data, setData] = useState([]);
  const [isUserNotSearched, setIsUserNotSearched] = useState(false);
  const [isDatafetched, setIsDatafetched] = useState(false);
  const [isApihitcomplete, setIsApihitcomplete] = useState(false);
  const [search, setSearch] = useState("");
  const [colors, setColors] = useState(config?.colors);
  const navigate=useNavigate()
  const oldData = useRef([]);

  const getSubordinatesList = (empid) => {
    if (!empid) return;

    setIsApihitcomplete(false);

    const obj = {
      query: "HRApp_Droid_Proc_Manager_Subordinates_GetList @EmpID='{0}'",
      queryArr: [`${empid}`],
    };

    Hexapi(obj)
      .then((resp) => {
        if (resp[""] && resp[""].length > 0) {
          setData(resp[""]);
          oldData.current = resp[""];
          setIsDatafetched(true);
        } else {
          setIsDatafetched(false);
        }
      })
      .finally(() => setIsApihitcomplete(true))
      .catch((err) =>
        console.log("Subordinates list fetch error:",err))
  };


  useEffect(() => {
    const dataget = decodeUrl(window.location.search);

    const Empidget = dataget?.id || props?.userid;
    const Usernameget = dataget?.name || props?.username;

    setEmpID(Empidget);
    setUsername(Usernameget);

    if (!Empidget) return;

    let newName =
      Empidget == props?.userid ? "Your" : `${Usernameget}'s`;

    const event = new CustomEvent("myCustomEvent", {
      detail: { header: `${newName} Subordinates` },
    });

    window.parent.document.dispatchEvent(event);

    getSubordinatesList(Empidget);
  }, []);

 
  useEffect(() => {
    if (props?.userid !== userid) {
      setUserid(props?.userid);
      getSubordinatesList(EmpID);
    }
  }, [props?.userid]);




  const getCheckingBgcolor = (status) => {
    if (status === 0) return colors?.Overtime;
    if (status === 1) return colors?.Work;
    return "";
  };

  const storeSearch = (value) => {
    setSearch(value);

    if (value === "") {
      setData(oldData.current);
      setIsUserNotSearched(false);
      return;
    }

    const filtered = oldData.current.filter((user) =>
      `${user.firstname} ${user.lastname}`
        .toLowerCase()
        .includes(value.toLowerCase())
    );

    if (filtered.length > 0) {
      setData(filtered);
      setIsUserNotSearched(false);
    } else {
      setIsUserNotSearched(true);
    }
  };

  
  if (!isApihitcomplete) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
          <Loader/>
      </div>
    );
  }

  if (!isDatafetched) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <h5 style={{ color: "#ff6d00" }}>No Subordinates!</h5>
      </div>
    );
  }

  return (
    <div style={{ overflow: "hidden" }}>
      <div
        className="container-fluid listviewmainbox"
        style={{ backgroundColor: colors?.bgcolor }}>
        <div className="row">        
          <div className="col-12 d-flex justify-content-end">
            <div style={{ height: "6vh", padding: "10px 0px" }}>
              <SearchComponent
                searchvalue={search}
                storeSearch={(val) => storeSearch(val)}
              />
            </div>
          </div>

          {isUserNotSearched ? (
            <div className="d-flex justify-content-center align-items-center vh-100">
              <p style={{ color: "#ff6d00", fontSize: "18px" }}>
                No User Found
              </p>
            </div>
          ) : (
            <div style={{
                height: "93vh",
                overflow: "auto",
                paddingBottom: "200px",
                paddingLeft: "10px",
                paddingRight: "10px",
              }}>
               <div
              className="row listview g-1"
              
            >
              {data.map((list, index) => (
                <div key={index} className="col-lg-4 col-md-6 p-1">
                  <div
                    className="tilesubordinate"
                    onClick={() =>navigate(`/profile?${btoa(
                        `id=${list.empid}&IsShowArrow=true`
                      )}`)
                    }
                  >
                    <div className="image">
                      <div
                        className="innerImageBox"
                        style={{
                          border: `3px solid ${getCheckingBgcolor(
                            list.curshiftstatus
                          )}`,
                          borderRadius: "50%",
                        }}
                      >
                        <div
                          className="imglastinnerbox"
                          style={{
                            border: "2px solid #fff",
                            borderRadius: "50%",
                          }}
                        >
                          <GetImage
                            imgID={list.empid}
                            width="60px"
                            height="60px"
                            top
                            redirection
                          />
                        </div>
                      </div>

                      {list.amuser != -1 && (
                        <div className="userCheckinIconsub">
                          <img
                            src={
                              list.amuser == 0
                                ? appUser
                                : amUser
                            }
                            alt="user"
                             style={{ filter: Tint(colors?.Primary) }}
                          />
                        </div>
                      )}
                    </div>

                    <div className="description">
                      <p>
                        {list.firstname} {list.lastname}
                      </p>
                    </div>

                    {list.empscore != -1 && (
                      <div className="redflagCategoryIcon">
                        <TicketScore kpiscore={list.empscore} />
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
              </div>  
          )}
        </div>
      </div>
    </div>
  );
};

export default withRouter(ListView);